import React from 'react';
import styles from './Hint.module.scss';
import cx from 'classnames';

const Hint = ({ text, className }) => {
  return <div className={cx(styles.container, className)}>{text}</div>;
};

export default Hint;
